var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAvatarIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#avatar-icon_svg__paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 41a7 7 0 00-7 7v2a1 1 0 11-2 0v-2a9 9 0 1118 0v2a1 1 0 11-2 0v-2a7 7 0 00-7-7z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 39a4 4 0 100-8 4 4 0 000 8zm0 2a6 6 0 100-12 6 6 0 000 12z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "avatar-icon_svg__paint0_linear",
    x1: 11,
    y1: 15,
    x2: 69,
    y2: 74.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiByeD0iNDAiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcikiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00MCA0MUMzNi4xMzQgNDEgMzMgNDQuMTM0IDMzIDQ4VjUwQzMzIDUwLjU1MjMgMzIuNTUyMyA1MSAzMiA1MUMzMS40NDc3IDUxIDMxIDUwLjU1MjMgMzEgNTBWNDhDMzEgNDMuMDI5NCAzNS4wMjk0IDM5IDQwIDM5QzQ0Ljk3MDYgMzkgNDkgNDMuMDI5NCA0OSA0OFY1MEM0OSA1MC41NTIzIDQ4LjU1MjMgNTEgNDggNTFDNDcuNDQ3NyA1MSA0NyA1MC41NTIzIDQ3IDUwVjQ4QzQ3IDQ0LjEzNCA0My44NjYgNDEgNDAgNDFaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQwIDM5QzQyLjIwOTEgMzkgNDQgMzcuMjA5MSA0NCAzNUM0NCAzMi43OTA5IDQyLjIwOTEgMzEgNDAgMzFDMzcuNzkwOSAzMSAzNiAzMi43OTA5IDM2IDM1QzM2IDM3LjIwOTEgMzcuNzkwOSAzOSA0MCAzOVpNNDAgNDFDNDMuMzEzNyA0MSA0NiAzOC4zMTM3IDQ2IDM1QzQ2IDMxLjY4NjMgNDMuMzEzNyAyOSA0MCAyOUMzNi42ODYzIDI5IDM0IDMxLjY4NjMgMzQgMzVDMzQgMzguMzEzNyAzNi42ODYzIDQxIDQwIDQxWiIgZmlsbD0id2hpdGUiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjExIiB5MT0iMTUiIHgyPSI2OSIgeTI9Ijc0LjUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iY3VycmVudENvbG9yIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iY3VycmVudENvbG9yIiBzdG9wLW9wYWNpdHk9IjAiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };